<template>
  <v-app id="login" class="primary ">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center d-flex flex-column ga-8 class="login-inner">
          <v-flex class="login-form-outer" v-bind:class="{ authDisabled: lockedAttempt }">
            <v-card class="login-form-wrapper pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img class="login-logo" :src="'./static/pg-logo.jpg'" alt="POH Admin" width="60" height="60">
                </div>
                <v-form lazy-validation>
                  <v-text-field append-icon="person" name="login" label="Логин" type="text" v-model="model.login"
                    :rules="[rules.required]" v-on:keyup.enter="login" required></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="Пароль" id="password" type="password"
                    v-model="model.password" :rules="[rules.required]" v-on:keyup.enter="login" required></v-text-field>
                </v-form>
              </v-card-text>
              <v-switch style="margin-left:1em" name="remember" label="Запомнить меня" id="remember"
                v-model="model.remember"></v-switch>
              <v-card-actions>
                <v-btn block class="login-button" color="primary" @click="login"
                  :loading="loading">Авторизоваться</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex class="login-otp-form-wrapper" v-if="!skipOtp && model.loginPrefetched">
            <div class="triangle"></div>
            <v-card class="login-otp-form-outer">
              <div class="otp-code-reset-auth" @click="resetAuthorization()"><span
                  class="otp-code-reset-inline-button">Сбросить</span></div>
              <div class="otp-code-title">Введите код подтверждения, полученный на <span class="otp-login-detail">{{
                model.loginPrefetched }}</span></div>

              <div class="otp-code-form-inner">
                <input pattern="\d{1}" @paste="handlePaste($event)" maxlength="1" type="text" @input="watchCode($event)"
                  class="singular-code" v-for="input in inputs" :key="input.id" :id="'otp-input-' + input.id"
                  v-bind:class="{ codeDisabled: checkCodeOngoing }">
              </div>

              <div class="otp-code-retry"><span v-bind:class="{ authDisabled: lockedCodeAttempt }"
                  @click="requestAttempt($event)" class="otp-code-retry-inline-button">Запросить</span> новый через
                <span class="otp-timer">...</span>
              </div>
            </v-card>
          </v-flex>
          <div class="otp-code-retry-count" v-if="!skipOtp && model.loginPrefetched">{{ retryCount }}/{{
            model.retryCountTotal }}
          </div>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<style scoped>
.layout.login-inner.align-center.justify-center.d-flex.flex-column.ga-8 {
  max-height: 75%;
}

.login-otp-form-outer.v-card {
  flex-direction: column;
}

.codeDisabled {
  pointer-events: none;
  opacity: .5;
  filter: grayscale(1);
}

.banhammered .v-snack__wrapper {
  border: 1px solid #8000ff !important;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: rgb(128, 0, 255);
  box-shadow: inset 0px 2px 12px #df00ff47;
  border-bottom: 0px !important;
}

.authDisabled {
  opacity: .5;
  pointer-events: none;
}

.otp-code-reset-inline-button {
  cursor: pointer;
}

.otp-code-reset-inline-button:hover {
  color: black;
}

.triangle {
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 25px 15px 25px;
  border-color: transparent transparent #FFFFFF transparent;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  margin: 0 auto;
}

.flex.login-form-outer {
  /*box-shadow: 0px 50px 75px #0c105391;
  z-index: 99;*/
}

.otp-code-retry-inline-button {
  cursor: pointer;
}

.login-otp-form-outer.v-card.v-sheet div,
.login-otp-form-outer.v-card.v-sheet input,
.login-otp-form-outer.v-card.v-sheet span {
  transition: .25s all ease-in-out !important;
}

.otp-code-retry-count {
  border: 1px solid #ffffff17;
}

.singular-code {
  transition: .25s all ease-in-out !important;
}

.otp-code-retry-inline-button:hover {
  filter: brightness(1.2);
}

.otp-login-detail {
  text-decoration: underline dotted;
}

#login {
  background: url("data:image/svg+xml,%3Csvg width='502' height='117' viewBox='0 0 502 117' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M489 26C496.18 26 502 20.1797 502 13C502 5.8203 496.18 0 489 0C481.82 0 476 5.8203 476 13C476 20.1797 481.82 26 489 26ZM34.2131 87.7991L28.1037 116H0L19.2788 26H62.9956C73.5854 26 81.5956 28.8336 86.3474 34.3658C90.5562 39.0885 93 46.2399 93 53.5262C93 62.8366 88.927 72.5517 82.2745 79.1634C76.4365 84.9655 68.1547 87.7991 57.2934 87.7991H34.2131ZM38.8292 65.8051H52.6774C56.7504 65.8051 58.9226 64.9955 61.2307 62.8366C63.2672 60.8126 64.4891 57.979 64.4891 55.1454C64.4891 50.018 61.638 47.5892 55.6642 47.5892H42.7664L38.8292 65.8051ZM216.213 87.7991L210.104 116H182L188.899 83.792H180.5L173.548 116.176H155.884H150L151 112.5C151 112.5 146.796 116.176 138 116.176H132.332C123.5 116.176 114.668 112.848 108.652 107.216C101.612 100.56 97.132 89.424 97.132 78.544C97.132 64.208 103.404 48.848 113.516 38.864C121.964 30.416 133.228 26.448 148.204 26.448C157.932 26.448 164.972 28.112 170.86 31.696C179.052 36.688 183.66 44.88 183.66 54.736V54.7361C183.66 55.1202 183.66 56.0161 183.532 57.04H158.828C158.06 50.384 153.836 46.928 146.412 46.928C134.38 46.928 123.756 61.904 123.756 78.672C123.756 88.4 129.772 94.544 139.116 94.544C146.156 94.544 152.3 90.32 154.86 83.792H143.084L146.796 66.128H183.788H192.683L201.279 26H244.996C255.585 26 263.596 28.8336 268.347 34.3658C272.556 39.0885 275 46.2399 275 53.5262C275 62.8366 270.927 72.5517 264.274 79.1634C258.436 84.9655 250.155 87.7991 239.293 87.7991H216.213ZM220.829 65.8051H234.677C238.75 65.8051 240.923 64.9955 243.231 62.8366C245.267 60.8126 246.489 57.979 246.489 55.1454C246.489 50.018 243.638 47.5892 237.664 47.5892H224.766L220.829 65.8051ZM353.832 33.5749C347.135 28.6961 338.376 26 328.974 26C315.321 26 303.987 30.4936 294.327 39.7375C284.667 49.1098 279 62.9757 279 77.2268C279 89.9372 283.508 100.337 291.88 107.013C299.093 112.79 309.01 116 319.572 116C347.006 116 368 93.9173 368 65.1583C368 51.164 363.234 40.3795 353.832 33.5749ZM314.291 53.6034C318.155 48.9815 322.92 46.5421 328.201 46.5421C336.315 46.5421 341.725 52.9615 341.725 62.4622C341.725 79.4094 331.292 94.3024 319.443 94.3024C311.329 94.3024 305.533 87.7546 305.533 78.3823C305.533 69.5235 308.881 60.2796 314.291 53.6034ZM401.465 79.9071H427.562L419.934 115H447.771L452.522 92.75L455.612 79.9071L470.772 79.907L476 55.4888H460.317L462.024 48.25L466.775 26H438.938L432.782 55.4888H406.685L412.975 26H385.004L380.253 48.25L370.751 92.75L366 115H393.971L401.465 79.9071Z' fill='white' fill-opacity='0.1'/%3E%3C/svg%3E%0A"), #0c1053 !important;
  background-position-x: 0%, 0%;
  background-position-y: 0%, 0%;
  background-repeat: repeat, repeat;
  background-size: auto, auto;
  background-size: 120% !important;
  background-repeat: no-repeat !important;
  background-position-y: 125% !important;
  background-position-x: 20% !important;
}

.otp-code-retry-count {
  color: white;
  padding: 6px;
  border-radius: 6px;
  background: #ffffff0f;
}

.admin-heading {
  padding: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
  background: #8080801c;
  border-radius: 6px;
  padding-bottom: 3px;
  padding-top: 3px;
  margin-top: 3px;
  color: gray;
  font-size: .85em;
}

.login-otp-form-outer.v-card.v-sheet.theme--light[data-v-a60344ca] {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  gap: .5em;
  flex-direction: column;
}

.otp-code-retry-inline-button {
  background: #3f51b5;
  padding: 6px;
  border-radius: 6px;
  margin-right: 6px;
  margin-top: 12px;
  color: white;
}

.login-otp-form-outer {
  gap: 1.4em !important;
}

.otp-code-form-inner {
  display: flex;
  gap: 0.5em;
}

.login-otp-form-outer {
  justify-content: space-between;
}

.singular-code {
  max-width: 50px !important;
  height: 75px !important;
  font-size: 3em;
  width: 100%;
}

.singular-code {
  border-radius: 6px !important;
}

.login-otp-form-outer.v-card {
  padding: 24px 24px !important;
  border-radius: 6px;
}

.singular-code {
  border-radius: 6px !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3f51b5;
}

.login-otp-form-outer {
  display: flex;
  justify-content: start;
}

.singular-code {
  border: 1px solid #80808038;
  border-radius: 6px;
  height: 100%;
  max-width: 15%;
  min-height: 50px;
  background: #8080800f;
}

.layout.login-inner.align-center.justify-center.d-flex.flex-column.ga-8 {
  display: flex;
  flex-direction: column;
  gap: 2em;
}

#login {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

.login-button {
  min-height: 50px;
  border-radius: 6px;
  font-size: 1.21em;
}

.login-form-wrapper {
  border-radius: 6px;
}

.flex.login-otp-form-outer.pa-3 {
  height: max-content;
  display: flex;
  align-items: center;
}

.flex.login-form-outer {
  width: 100%;
}

.flex.login-otp-form-wrapper {
  width: 100%;
}

.layout.login-inner {
  max-width: 20%;
  margin: 0 auto;
}

.otp-code-reset-auth {
  color: gray;
}

.otp-failure[data-v-a60344ca] {
  border: 1px solid #ff3f5a2e !important;
  -webkit-box-shadow: 0px 0px 12px #ff004833 !important;
  box-shadow: 0px 0px 12px #ff004833 !important;
  background: #ff2c402e !important;
  color: #c15050 !important;
}

.otp-success {
  border: 1px solid #ccff3f17 !important;
  box-shadow: 0px 0px 12px #dfff001a !important;
  background: #b3ff2c1a !important;
  color: #728611 !important;
}

@media (min-width: 1440px) and (max-width: 1750px) {
  .layout.login-inner {
    max-width: 30%;
    margin: 0 auto;
  }
}

@media (min-width: 1100px) and (max-width: 1440px) {
  .layout.login-inner {
    max-width: 40%;
    margin: 0 auto;
  }
}

@media (min-width: 700px) and (max-width: 1100px) {
  .layout.login-inner {
    max-width: 50%;
    margin: 0 auto;
  }
}

@media (max-width: 700px) {
  .layout.login-inner {
    max-width: 85%;
    margin: 0 auto;
  }
}
</style>

<script>

import { mapActions } from 'vuex';
import * as crypto from "crypto-js";
import Logging from '../store/modules/logging';
import UserStatus from '../store/modules/userStatus';
//import AppConfig from './appconfig.json';

export default {
  data: () => ({
    skipOtp: true,
    checkStatus: {},
    loading: false,
    authToken: '',
    inputs: 0,
    checkCodeOngoing: false,
    lockedAttempt: false,
    lockedCodeAttempt: false,
    timerObject: null,
    timeMax: 30,
    timeLeft: 30,
    code: '',
    retryCount: 1,
    baseUrl: '',
    model: {
      login: '',
      password: '',
      remember: true,
      loginPrefetched: '',
      fullnamePrefetched: '',
      userLogin: '',
      loggingDataSet: false,
      defaults: {
        codeLength: 6,
        keepAliveSeconds: 3600,
        retryCountTotal: 3,
        rolesWhiteList: []
      },
      mfaSettings: {
        otpServiceBasePath: '',
        otpAcquireTokenPath: 'auth',
        otpAssertTokenPath: 'auth/check',
        otpDischargeTokenPath: 'auth/logout',
        otpAcquireCodePath: 'codes',
        otpAssertCodePath: 'codes/check',
        otpSettingPath: 'settings',
        laServiceBasePath: ''
      },
      codeLength: 6,
      retryCountTotal: 3,
      rolesWhiteList: '',
    },
    rules: {
      required: (value) => !!value || 'Обязательное поле.',
    }
  }),
  mounted() {
    //this.getInputs();
    this.baseUrl = this.getBaseUrl();
    this.model.mfaSettings.laServiceBasePath = this.getLaServiceBasePath();
    this.model.mfaSettings.otpServiceBasePath = this.getOtpServiceBasePath();

    this.$store.dispatch('userStatus/saveSettingsToStorage').then(() => {
      this.$store.dispatch('userStatus/updateDefaultNotificationTextFromSettings');
      this.$store.dispatch('userStatus/updateDefaultTimerFromSettings');
      console.warn('UserStatus mounted.');
      console.debug(this.$store.getters['userStatus/notificationText'])
      this.$forceUpdate();
    });

    console.debug('OPTIONS: ', this.model.mfaSettings.otpServiceBasePath, this.baseUrl, this.baseUrl, this.model.mfaSettings.laServiceBasePath);
    this.setOtpSettings();
  },
  methods: {
    getOtpServiceBasePath() {
      return this.$store.state.mfaUrl;
    },

    getLaServiceBasePath() {
      return this.$store.state.laUrl;
    },

    getBaseUrl() {
      return this.$store.state.netUrlExchangePath;
    },

    getInputs() {
      this.inputs = [];
      for (let i = 0; i < this.model.codeLength; i++) {
        this.inputs.push({ id: i });
      }
      //console.debug('inputs', this.inputs);
    },

    encryptMd5(message) {
      return crypto.MD5(message).toString();
    },

    watchCode(event) {
      if (this.retryCount >= this.model.retryCountTotal) {
        this.resetAuthorization();
        console.warn('No retries left.');
        window.getApp.$emit('APP_LOGIN_OTP_NO_RETRIES_LEFT')
        return;
      }
      //console.debug(event)
      this.limitInputLength(event.target);
      this.code = this.getCombinedCode();
      //console.log(`Digit pressed: ${event.target.value}`);
      if (this.code.length == this.model.codeLength) {
        this.lockedAttempt = true;
        this.checkCode().then((response) => {
          if (!this.checkCodeOngoing) {
            this.checkCodeOngoing = true;
            //console.warn('Code response is ' + response)
            if (response) {
              this.markCorrect();
              this.normalLogin();
            } else {
              this.markIncorrect();
              //this.lockedCodeAttempt = false;
              this.retryCount++;
            }
          }
        });
      }
    },

    resetAuthorization() {
      document.querySelector('input[name="login"]').value = '';
      document.querySelector('input[name="password"]').value = '';

      this.lockedAttempt = false;
      this.lockedCodeAttempt = false;

      this.authToken = '';
      localStorage.removeItem('authToken');

      this.retryCount = 1;
      this.model.loginPrefetched = '';
      this.removeMarkings();
    },

    lockAttempt() {
      this.lockedCodeAttempt = true;
      this.lockedAttempt = true;
    },

    unlockAttempt() {
      this.lockedCodeAttempt = false;
      //this.lockedAttempt = false;
    },

    requestAttempt(t) {
      this.lockAttempt();
      this.timeLeft = this.timeMax;
      this.startTimer();
      return this.init2FaCode(this.authToken);
    },

    checkCode() {
      this.code = this.getCombinedCode();
      this.lockedCodeAttempt = true;
      return this.check2FaCode(this.authToken, this.code);
    },

    handlePaste(event) {
      let inputs = document.querySelectorAll('input.singular-code');
      let clipBoard = event.clipboardData.getData('text');
      const text = clipBoard.replace(/\s|-/g, "");
      const chars = [...text];
      inputs.forEach((element, index) => element.value = chars[index] == null ? "" : chars[index]);
      inputs[inputs.length - 1].focus();
      this.watchCode(event);
    },

    limitInputLength(element) {
      if (element.value.length > 1) {
        element.value = element.value.substr(0, 1);
      }
      if (element.value.length >= 1) {
        if (typeof document.getElementById('otp-input-' + (Number(element.getAttribute('id').slice(-1)) + 1)) != 'undefined' && document.getElementById('otp-input-' + (Number(element.getAttribute('id').slice(-1)) + 1)) != null) {
          document.getElementById('otp-input-' + (Number(element.getAttribute('id').slice(-1)) + 1)).focus();
        }
      }
    },

    markIncorrect() {
      let inputs = document.querySelectorAll('input.singular-code');
      inputs.forEach((input) => {
        input.classList.remove('otp-success');
        input.classList.add('otp-failure');
      });
      this.checkCodeOngoing = false;
    },

    markCorrect() {
      let inputs = document.querySelectorAll('input.singular-code');
      inputs.forEach((input) => {
        input.classList.remove('otp-failure');
        input.classList.add('otp-success');
      });
      this.checkCodeOngoing = false;
    },

    removeMarkings() {
      let inputs = document.querySelectorAll('input.singular-code');
      inputs.forEach((input) => {
        input.classList.remove('otp-failure');
        input.classList.remove('otp-success');
      });
      this.checkCodeOngoing = false;
    },

    getCombinedCode() {
      let code = '';
      let inputs = document.querySelectorAll('input.singular-code');
      inputs.forEach((input) => {
        code += input.value;
      });
      //console.debug('Code:', code)
      return code;
    },

    stripRawHtmlOfTagsRegex(html) {
      if (html == null) {
        return '';
      }
      return html.replace(/(<([^>]+)>)/gi, "");
    },

    parseSettingsIntoObject(serverResponse) {
      let resultingMap = this.model.defaults;

      //console.debug('serverResponse', serverResponse, resultingMap);

      if (!serverResponse && typeof serverResponse == 'undefined') {
        console.debug('ERROR: Settings objects couldnt be fetched, service unreachable.');
      } else {

        try {
          resultingMap.codeLength = serverResponse.find((object) => { return this.findSettingByUkeyValue('CODE.LENGTH', object) }).value;
          resultingMap.keepAliveSeconds = serverResponse.find((object) => { return this.findSettingByUkeyValue('CODE.ALIVE.SECONDS', object) }).value;
          resultingMap.retryCountTotal = serverResponse.find((object) => { return this.findSettingByUkeyValue('NUMBER.ATTEMPS', object) }).value;
          resultingMap.rolesWhiteList = serverResponse.find((object) => { return this.findSettingByUkeyValue('SEND.MFA.CODE.ROLES.ADMIN', object) }).value.split(',');
        } catch (e) {
          console.debug('OTP settings getter ERROR: ', e);
        }
        //console.debug('Settings: ', resultingMap);
      }

      return resultingMap;
    },

    findSettingByUkeyValue(ukey, object) {
      return object.ukey == ukey;
    },

    startTimer() {
      this.timerObject = setInterval(() => {
        if (this.timeLeft == -1) {
          clearTimeout(this.timerObject);
          this.timeLeft = 0;
          this.unlockAttempt();
        } else {
          if (document.querySelector('.otp-timer') != null) {
            document.querySelector('.otp-timer').innerHTML = this.timeLeft;
            this.timeLeft--;
          } else {
            clearTimeout(this.timerObject);
            this.timeLeft = 0;
            this.unlockAttempt();
          }
        }
      }, 1000);
    },

    async init2FaCode(token) {
      let username = 'admin',
        password = 'admin';

      const credentials = btoa(`${username}:${password}`)
      const auth = {
        "Authorization": `Basic ${credentials}`,
        "jwt": token,
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=utf-8"
      }

      let url = encodeURI(`${this.model.mfaSettings.otpServiceBasePath}${this.model.mfaSettings.otpAcquireCodePath}`);

      try {
        let response;
        let result;

        const requestOptions = {
          method: "POST",
          headers: auth,
          redirect: "follow"
        };

        response = await fetch(url, requestOptions)
          .then((response) => {
            if (typeof response == 'undefined') {
              return false;
            }
            if (response.status != 200) {
              return false;
            }
            response.text().then((code) => {
              result = code;
              console.warn(code);
            });
          })
          .catch((error) => console.error(error));

        return result;
      } catch (e) {
        return false;
      }
    },

    async check2FaCode(token, code) {
      let username = 'admin',
        password = 'admin';

      const credentials = btoa(`${username}:${password}`)
      const auth = {
        "Authorization": `Basic ${credentials}`,
        "jwt": token,
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=utf-8"
      }

      let url = encodeURI(`${this.model.mfaSettings.otpServiceBasePath}${this.model.mfaSettings.otpAssertCodePath}?code=${code}`);

      try {
        let result;

        const requestOptions = {
          method: "POST",
          headers: auth,
          redirect: "follow"
        };

        let response = await fetch(url, requestOptions);

        if (typeof response == 'undefined') {
          //this.lockedCodeAttempt = true;
          return false;
        }
        if (response.status != 200) {
          //this.lockedCodeAttempt = false;
          return false;
        }

        result = await response.text();

        if (result == '0') {
          //this.lockedCodeAttempt = false;
          return false;
        }
        if (result.length > 1) {
          window.getApp.$emit('APP_LOGIN_OTP_SUCCESS')
          //this.lockedCodeAttempt = false;
          return true;
        }

        //this.lockedCodeAttempt = false;
        return false;

      } catch (e) {
        //this.lockedCodeAttempt = false;
        return false;
      }
    },

    async requestSettings() {
      let username = 'admin',
        password = 'admin';

      const credentials = btoa(`${username}:${password}`)
      const auth = { "Authorization": `Basic ${credentials}` }

      let url = encodeURI(`${this.model.mfaSettings.otpServiceBasePath}${this.model.mfaSettings.otpSettingPath}`);

      try {
        let response;
        let result;

        const requestOptions = {
          method: "GET",
          headers: auth,
          redirect: "follow"
        };

        response = await fetch(url, requestOptions);
        result = await response.json();

        //console.debug('OTP prefetched settings:', result);

        if (typeof result.content == 'undefined') {
          return false;
        }

        //console.debug('Options: ', result.content);

        let settingsObjects = [];

        result.content.filter((setting, index) => {
          result.content[index].value = this.stripRawHtmlOfTagsRegex(setting.value);
        });

        //console.debug('Options: ', result.content);

        //console.debug('OTP fetched settings:', settingsObjects);

        return result.content;
      } catch (e) {
        console.debug(e);
        return false;
      };
    },

    async preloadUser(identificator, password) {
      return new Promise((resolve, reject) => {

        if (!identificator) {
          throw 'No email/phone provided';
        } else {

          this.skipOtp = true;

          const auth = {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": "application/json;charset=utf-8",
            'X-User-Name': identificator,
            'X-User-Password': password
          }

          const requestOptions = {
            method: "POST",
            headers: auth,
            redirect: "follow"
          };

          fetch(this.baseUrl + 'mrs-ref-accounts-prefetch', requestOptions)
            .then((response) => {
              if (typeof response == 'undefined') {
                console.debug('Response undefined.');
                resolve(false);
                return false;
              }

              /*if (response.status != 200) {
                resolve(false);
              }*/
              response.json().then(async (result) => {
                if (typeof result == 'undefined' || typeof result[0] == 'undefined') {
                  console.debug('Result undefined.');
                  resolve(false);
                  return false;
                }

                // Предварительная проверка статуса, запрет определенных действий
                if (typeof result[0].userStatus != 'undefined' && result[0].userStatus != null) {
                  if (result[0].userStatus === 0) {
                    window.getApp.$emit('APP_LOGIN_USER_STATUS_LOCKED')
                    resolve(-1);
                    return -1;
                  }
                }

                if (result[0].roleKey != null) {
                  this.roleKey = result[0].roleKey;
                }

                if (result[0].username != null) {
                  this.model.userLogin = result[0].username;
                }

                /*console.debug(result[0]);
                if (this.model.rolesWhiteList.includes(result[0].roleKey)) {
                  this.roleKey = result[0].roleKey;
                }*/

                if (result[0].fullname != null) {
                  this.model.fullnamePrefetched = result[0].fullname;
                }

                if (result[0].phone != null) {
                  this.model.phonePrefetched = result[0].phone;
                }

                if (result[0].email != null) {
                  this.model.emailPrefetched = result[0].email;
                }

                if (result[0].email != null) {
                  this.model.loginPrefetched = result[0].email;
                  resolve(true);
                  return true;
                } else if (result[0].phone != null) {
                  this.model.loginPrefetched = result[0].phone;
                  resolve(true);
                  return true;
                } else {
                  resolve(false);
                  return false;
                }
              });
            })
            .catch((error) => {
              this.skipOtp = true;
              console.error(error);
              resolve(false);
              return false;
            });
        }
      });
    },

    async setOtpSettings() {
      try {
        let response = await this.parseSettingsIntoObject(await this.requestSettings());

        console.debug(response)

        this.model.codeLength = response.codeLength;
        this.model.keepAliveSeconds = response.keepAliveSeconds;
        this.model.retryCountTotal = response.retryCountTotal;
        this.model.rolesWhiteList = response.rolesWhiteList;
        this.getInputs();
        this.$forceUpdate();
      } catch (e) {
        throw e;
      }
    },

    async checkUserStatus() {
      let checkStatus = null;
      try {
        checkStatus = await this.$store.dispatch('userStatus/checkStatus', { userLogin: this.model.login });
      } catch (error) {
        return 1;
      }

      if (checkStatus != null) {
        console.log('UserStatus: ', checkStatus);
        if (checkStatus == 0) {
          window.getApp.$emit('APP_LOGIN_USER_STATUS_LOCKED')
          console.warn('APP_LOGIN_USER_STATUS_LOCKED');
          await this.$store.dispatch('logging/commitLogData', { eventKey: '101', username: this.model.login, payload: this.loggingData().payload['101'] });
          return 0;
        } else {
          return 1;
        }
      }
      return -1;
    },

    async mfaLogin(login, passwordHash, rememberSession) {
      let types = ['email', 'sms']; // TODO: брать из апи

      //console.debug('Auth data:', login, passwordHash);

      let projectUkey = 'poh';
      let typeUkey = login.includes('@') ? types[0] : types[1];
      let tokenKeepAliveDefault = 1073741824;

      let username = 'admin',
        password = 'admin';

      const credentials = btoa(`${username}:${password}`)
      const auth = {
        "Authorization": `Basic ${credentials}`,
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=utf-8"
      }

      let body = JSON.stringify(
        {
          "userUid": "",
          "projectUkey": projectUkey,
          "typeUkey": typeUkey,
          "jwtExpirationMs": rememberSession ? 432000000 : 86400000, // 86400000 - 24 часа | 432000000 - 7 дней | 2629746000 - месяц 
          "login": login,
          "passwordHash": passwordHash
        });

      let url = encodeURI(`${this.model.mfaSettings.otpServiceBasePath}${this.model.mfaSettings.otpAcquireTokenPath}`);

      try {
        let response;
        let result;

        const requestOptions = {
          method: "POST",
          headers: auth,
          body: body,
          redirect: "follow"
        };

        response = await fetch(url, requestOptions)
          .then(async (response) => {
            if (typeof response == 'undefined') {
              return false;
            }
            if (response.status != 200) {
              return false;
            }

            result = response.text();

          })
          .catch((error) => {
            console.error(error)
            return false;
          });

        return result;
      } catch (e) {
        return { error: e };
      }
    },

    async login() {
      try {
        let prefetchResult = await this.preloadUser(this.model.login, this.encryptMd5(this.model.password));
        if (typeof prefetchResult != 'undefined') {
          console.warn('Prefetch complete:', this.model.loginPrefetched, this.model.fullnamePrefetched);

          if (prefetchResult == -1) {
            this.skipOtp = true;
            window.getApp.$emit('APP_LOGIN_USER_STATUS_LOCKED');
          } else if (!prefetchResult) {
            this.skipOtp = true;
            window.getApp.$emit('APP_LOGIN_USER_PRELOADED_FAILURE');
          } else {

            /*let checkStatus = await this.checkUserStatus();
            if (checkStatus == 1) {}*/

            let loginResult = await this.mfaLogin(this.model.loginPrefetched, this.encryptMd5(this.model.password), this.model.remember);

            if (typeof loginResult != 'undefined') {
              if (loginResult) {
                if (this.model.rolesWhiteList.includes(this.roleKey)) {
                  this.skipOtp = false;
                }

                console.warn('Login complete:', loginResult);
                this.authToken = loginResult;

                if (!this.skipOtp) {
                  await this.requestAttempt(this.authToken);
                } else {
                  this.normalLogin();
                }
              } else {
                await this.$store.dispatch('logging/commitLogData', { eventKey: '101', username: this.model.login, payload: this.loggingData().payload['101'] });
              }
            } else {
              await this.$store.dispatch('logging/commitLogData', { eventKey: '101', username: this.model.login, payload: this.loggingData().payload['101'] });
              window.getApp.$emit('APP_AUTH_FAILED')
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    getToken() {
      return this.$store.getters['auth/getToken'];
    },

    getFullName() {
      return this.$store.getters['auth/adminFullname'];
    },

    eraseLocalStorageItems(keepPage = true) {
      try {
        localStorage.removeItem('fullname');
        localStorage.removeItem('email');
        localStorage.removeItem('phone');
        localStorage.removeItem('username');
        if (!keepPage) {
          localStorage.removeItem('lastVisitedPage');
        }
        localStorage.removeItem('apiToken');
      } catch (e) {
        console.debug(e);
      }
    },

    setLocalStorageItems(apiToken, fullname) {
      let lastVisitedPage = 'staffs/accounts';

      if (typeof apiToken != 'undefined') {
        if (localStorage.lastVisitedPage != 'undefined' && localStorage.lastVisitedPage != null) {
          lastVisitedPage = localStorage.lastVisitedPage;
        } else {
          localStorage.lastVisitedPage = lastVisitedPage;
        }

        localStorage.fullname = fullname;
        localStorage.apiToken = apiToken;
        localStorage.authToken = this.authToken;

        console.debug(localStorage.fullname, localStorage.lastVisitedPage, localStorage.apiToken, this.authToken);
      } else {
        return false;
      }

      return true;
    },

    /**
     * Авторизация legacy
     */
    async normalLogin() {
      this.loading = true;
      if (this.model.login !== '' && this.model.password !== '') {
        //this.$store._actions.auth.dispatch('auth', this.model).then((response) => {
        this.auth(this.model).then(async (response) => {
          console.log(response);
          if (response && this.model.remember) {
            console.warn(response);
            let localStorageSet = false;

            try {
              localStorageSet = this.setLocalStorageItems(this.getToken(), this.getFullName());
            } catch (e) {
              console.debug('RememberMe Failed: ', e);
            }

            this.loading = false;
            try {
              await this.$store.dispatch('logging/commitLogData', { eventKey: '212', username: this.loggingData().username, payload: this.loggingData().payload['212'] });
              //await Logging.actions.commitLogData('212', this.loggingData().username, this.loggingData().payload['212']);
            } catch (error) {
              console.error(error)
            }
            localStorageSet ? window.getApp.$emit('APP_LOGIN_SUCCESS_REMEMBER_AND_REDIRECT') : window.getApp.$emit('APP_LOGIN_SUCCESS');
          } else if (response && !this.model.remember) {
            this.loading = false;
            this.eraseLocalStorageItems();
            try {
              await this.$store.dispatch('logging/commitLogData', { eventKey: '212', username: this.loggingData().username, payload: this.loggingData().payload['212'] });
              //await Logging.actions.commitLogData('212', this.loggingData().username, this.loggingData().payload['212']);
            } catch (error) {
              console.error(error)
            }
            window.getApp.$emit('APP_LOGIN_SUCCESS');
          } else {
            this.loading = false;
            window.getApp.$emit('APP_AUTH_FAILED');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          window.getApp.$emit('APP_SERVER_ERROR');
        });
      } else {
        this.loading = false;
        window.getApp.$emit('EMPTY_FIELDS_ERROR');
      }
    },

    loggingData() {
      if (!this.loggingDataSet) {
        this.setLocalStorageLoggingData();
      }
      return { username: this.model.loginPrefetched, payload: { '212': `Пользователь: ${this.model.fullnamePrefetched}, ${this.model.loginPrefetched}`, '101': `Логин: ${this.model.login}` } };
    },

    setLocalStorageLoggingData() {
      try {
        if (this.model.loginPrefetched) {
          localStorage.username = this.model.loginPrefetched;
        }
        if (this.model.emailPrefetched) {
          localStorage.email = this.model.emailPrefetched;
        }
        if (this.model.phonePrefetched) {
          localStorage.phone = this.model.phonePrefetched;
        }
        this.loggingDataSet = true;
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * Псевдоним для вызова функции авторизации
     */
    ...mapActions({
      auth: 'auth/auth'
    }),
  }

};
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue